import { Center, brand } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps['style'];
  className?: string;
  fill?: CSSStyleDeclaration['fill'];
  stroke?: CSSStyleDeclaration['stroke'];
  height?: string | number;
  width?: string | number;
  ariaLabel?: string;
};

export const HeartIcon = ({
  style,
  className,
  fill = 'transparent',
  height = '16',
  width = '16',
  stroke = brand.zorroCoal900,
  ariaLabel,
  ...rest
}: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        stroke={stroke}
        fill={fill}
        height={height}
        viewBox="0 0 22 22"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden={ariaLabel ? undefined : true}
        focusable="false"
        {...rest}
      >
        <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"></path>
      </svg>
    </Center>
  );
};
